import React from 'react';
import _get from 'lodash/get';
import { OfferPanel } from '@bytebrand/fe-ui-core-autobahn/compat';
import { FormattedNumber } from '@bytebrand/fe-ui-core-autobahn/compat';
import { isMobileOnly } from 'react-device-detect';
import { offers, THREE } from '@bytebrand/fe-ui-core-autobahn/constants';
import { THOUSAND } from '../../../../framework/constants/app';
import { getOfferSliders } from '@bytebrand/fe-ui-core-autobahn/utils';
import CheckoutOfferPanel from '../../../pages/CheckoutPage/CheckoutStepper/Content/PaymentDetails/CheckoutOfferPanel/CheckoutOfferPanel';
import styles from './OfferBlock.styl';
import classnames from 'classnames';
let timeout = null;
const OfferBlock = ({ t, setCommonUserConfig, vehicleId, priceTabIndex, financingConfig, componentType, isAlternative, isOfferDetailsAbo, isOfferDetailedTabs, onAboFaqClick, values, checkoutClassName, language, onCheckoutModalClick, maxFinancingFirstInstallment }) => {
    const onChange = (defaultKey, value, checkboxKey) => {
        const key = checkboxKey || defaultKey;
        const offerName = offers[priceTabIndex].name;
        if (defaultKey === 'annualMileage' || defaultKey === 'firstInstallment') {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setCommonUserConfig(vehicleId, {
                    comparable: {
                        [key]: value,
                        isUpdated: Math.round(Date.now() / THOUSAND)
                    },
                    [offerName]: { [key]: value }
                });
            }, 50);
        }
        else {
            setCommonUserConfig(vehicleId, {
                comparable: {
                    [key]: value,
                    isUpdated: Math.round(Date.now() / THOUSAND)
                },
                [offerName]: { [key]: value }
            });
        }
    };
    const offerName = offers[priceTabIndex].name;
    const propsCheckboxCommon = {
        onChange,
        reversed: true
    };
    const finalAdvice = {
        onChange,
        value: 'withFinalInstallment',
        label: t('modals:financing.finalAdvice'),
        checked: _get(financingConfig, 'financing.withFinalInstallment'),
        labelPlacement: 'start',
        ...propsCheckboxCommon
    };
    const additionalService = {
        value: 'withAddServices',
        description: offerName === 'buy' ? t('modals:financing.additionalService') : t('modals:financing.additionalServiceRate'),
        label: (React.createElement("span", { className: styles.checkboxPrice },
            "+",
            React.createElement(FormattedNumber, { numbersAfterDot: 0, value: _get(financingConfig, `${offerName}.addServicesCost`) }),
            "\u20AC")),
        labelPlacement: 'start',
        tooltipDescription: (React.createElement("div", { dangerouslySetInnerHTML: { __html: offerName === 'buy' ? t('modals:financing.additionalServiceTooltipToBuy') : t('modals:financing.additionalServiceTooltip') } })),
        checked: priceTabIndex === 2 ? true : _get(financingConfig, `${offerName}.withAddServices`),
        tooltipPosX: priceTabIndex === 2 ? 'left' : undefined,
        disabled: priceTabIndex === 2 ? true : undefined,
        ...propsCheckboxCommon
    };
    const transferInstallments = {
        value: 'withTransportation',
        description: t('modals:financing.transferInstallments'),
        label: (React.createElement("span", { className: styles.checkboxPrice },
            "+",
            React.createElement(FormattedNumber, { numbersAfterDot: 0, value: _get(financingConfig, `${offerName}.transportationCost`) }),
            "\u20AC")),
        labelPlacement: 'start',
        tooltipDescription: offerName === 'buy' ? t('modals:financing.transferInstallmentsTooltipToBuy') : t('modals:financing.transferInstallmentsTooltip'),
        checked: _get(financingConfig, `${offerName}.withTransportation`),
        tooltipPosX: priceTabIndex !== THREE ? 'left' : undefined,
        ...propsCheckboxCommon
    };
    const rangeGroupProps = {
        onChange,
        sliders: offerName !== 'buy' && getOfferSliders(financingConfig, t, priceTabIndex, componentType),
        isAlternative,
        maxFinancingFirstInstallment
    };
    const offerPeriodProps = {
        t,
        onChange,
        priceTabIndex,
        name: 'paybackPeriod',
        periods: offers[priceTabIndex].periods,
        paybackPeriod: _get(financingConfig, `${offerName}.paybackPeriod`),
        isAlternative
    };
    const aboAccordionProps = {
        priceTabIndex,
        isOfferDetailsAbo,
        isOfferDetailedTabs,
        isMobileOnly,
        additionalService,
        transferInstallments,
        onAboFaqClick
    };
    const offerPanelProps = {
        t,
        financingConfig,
        priceTabIndex,
        isOfferDetailsAbo,
        finalAdvice,
        additionalService,
        transferInstallments,
        rangeGroupProps,
        offerPeriodProps,
        aboAccordionProps,
        values,
        checkoutClassName,
        language,
        onCheckoutModalClick,
        isAlternative
    };
    const offerBlockClasses = classnames(styles.offerBlock, checkoutClassName);
    const Component = { main: OfferPanel, checkout: CheckoutOfferPanel }[componentType];
    return (React.createElement("div", { className: offerBlockClasses },
        React.createElement(Component, { ...offerPanelProps })));
};
OfferBlock.defaultProps = {
    language: 'de',
    isAlternative: false,
    isOfferDetailsAbo: false,
    checkoutClassName: '',
    onCheckoutModalClick: () => { },
    values: null
};
export default OfferBlock;
